import {
  InfiniteData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import CommentsAPI from "../../api/CommentsAPI";
import { CommentsQuery } from "./useFetchComments";

interface Props {
  commentID: string;
  context: string;
  contextID: string;
}

export default function useDeleteComment() {
  const client = useQueryClient();

  const deleteComment = useMutation({
    mutationFn: ({ commentID }: Props) => CommentsAPI.deleteComment(commentID),
    onMutate: ({ commentID, context, contextID }) => {
      client.setQueryData<InfiniteData<CommentsQuery>>(
        ["comments", context, contextID],
        (prev) => {
          if (!prev) return prev;

          for (const page of prev.pages) {
            let foundIndex = page.comments.findIndex(
              (c) => c._id === commentID
            );

            if (foundIndex < 0) continue;

            page.comments[foundIndex] = {
              ...page.comments[foundIndex],
              Deleted:
                typeof page.comments[foundIndex]?.Deleted === "boolean"
                  ? !page.comments[foundIndex].Deleted
                  : true,
            };
          }

          return prev;
        }
      );
    },
  });

  return { deleteComment: deleteComment.mutate };
}
